import axiosInstance from './AxiosInstance';

export function getAgents() {
    return axiosInstance.get(`agents`);
}

export function createAgent(userData) {
    return axiosInstance.post(`/agent`, userData);
}

export function updateAgent(userData) {
    return axiosInstance.put(`/agent/update`, userData);
}


export function deleteAgents(userId) {
    return axiosInstance.delete(`/agent/${userId}`);
}
